<template>
  <div id="select">
    <div class="select_box">
      <span class="label_name">{{Name}}</span>
      <el-select class="input_sty" v-model="Sex" @change="changeVal(option)">
        <el-option
          v-for="(item,index) in options"
          :key="index"
          :label="item.label"
          :value="item.value"
        ></el-option>
      </el-select>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      options: this.option,
      Sex: "全部模块",
      Name: this.name
    };
  },
  props: {
    option: Array,
    name: String,
    field: { type: String }
  },
  methods: {
    changeVal() {
      this.$emit("changeVal", this.Sex, this.field);
    }
  }
};
</script>

<style lang="less">
#select {
  .select_box {
    border: 1px solid #dcdfe6;
    width: 100%;
    border-radius: 5px;
    display: flex;
    .label_name {
      color: #666;
      height: 100%;
      text-align: center;
      white-space: nowrap;
      line-height: 28px;
      font-size: 12px;
      margin-left: 5px;
      font-weight: bold;
      display: inline-block;
    }

    .el-input__prefix,
    .el-input__suffix {
      top: -8px;
      height: auto;
    }
    .el-input__inner {
      width: 100%;
      border: none;
      height: 28px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Input/seleck/seleck.vue